import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService, StorageService } from '@app/core/services';

export const isSignedInGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const storageService = inject(StorageService)
  
  if (authService.isAuthenticated()) {
    return true;
  } else {
    if (storageService.token && storageService.userEmail && storageService.userPassword) {
      return authService.autoLogin()
    }
  }
  authService.logout();
  return false;
};
